import { render } from "./ContactContainer.vue?vue&type=template&id=56ca9d1a"
import script from "./ContactContainer.vue?vue&type=script&lang=js"
export * from "./ContactContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__